module.exports = __webpack_public_path__ + "img/white-arrow-left.c1814cb2.svg";